'use client';

import useSWR from 'swr';
import isEmpty from 'lodash/isEmpty';

import BlogCard from '@/app/components/blog/card/BlogCard';

const Latest = ({ title, limit = 2, actualId = null }) => {
  const { data } = useSWR(`/api/lib/v1/blogs?perPage=${limit}`, url =>
    fetch(url).then(r => r.json()),
  );
  const articles = data?.articles;
  if (isEmpty(articles)) {
    return null;
  }

  let lastIndex = 1;

  return (
    <div className={'py-6'}>
      {title ? <h3>{title}</h3> : ''}
      <div className={'grid gap-4'}>
        {articles.map((article, index) => {
          if (article?.id == actualId) {
            lastIndex = lastIndex + 1;
            return '';
          }
          if (!(index <= lastIndex)) {
            return '';
          }
          return (
            <div key={`blog-article-${article?.id}-${index}`}>
              <BlogCard blog={article} />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Latest;
